// extracted by mini-css-extract-plugin
export default {"inline":"pageTurning_inline__4+jL0","width-50":"pageTurning_width-50__e3Fll","pageStyle":"pageTurning_pageStyle__OGQFE"};